import { Component, EventEmitter, Output } from '@angular/core';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';

@Component({
  selector: 'app-numeric-keypad',
  templateUrl: './numeric-keypad.component.html',
  styleUrls: ['./numeric-keypad.component.scss'],
})
export class NumericKeypadComponent {
  @Output() keyPress = new EventEmitter<string>();
  @Output() backspace = new EventEmitter<void>();

  @Output() focusUp = new EventEmitter<void>();
  @Output() focusRight = new EventEmitter<void>();
  @Output() focusDown = new EventEmitter<void>();
  @Output() focusLeft = new EventEmitter<void>();

  readonly keys: string[][] = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['0', 'BACK'],
  ];

  constructor(private readonly navService: NavigationLibraryService) {}

  ngOnInit(): void {
    this.navService.focusContainer('numeric-keypad', false, 0, false, 150);
  }

  onKeyClick(key: string) {
    if (key === 'BACK') {
      this.backspace.emit();
    } else {
      this.keyPress.emit(key);
    }
  }

  /**
   * Handles all arrow key navigation events
   */
  onKeyDown(event: KeyboardEvent, i: number, j: number): void {
    if (event.isUp()) {
      if (i === 0) {
        this.focusUp.emit();
        this.disable(event);
      }
    } else if (event.isDown()) {
      if (i === this.keys.length - 1) {
        this.focusDown.emit();
        this.disable(event);
      }
    } else if (event.isLeft()) {
      if (j === 0) {
        this.focusLeft.emit();
        this.disable(event);
      }
    } else if (event.isRight()) {
      const rowLength = this.keys[i].length;
      if (j === rowLength - 1) {
        this.focusRight.emit();
        this.disable(event);
      }
    }
  }

  disable(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
}
